import { Box, styled } from "@mui/material";

const ConfiguratorInnerBox = styled(Box)(({ theme }) => ({
    marginLeft: "16px",
    marginBottom: "0px",
    marginRight: "16px",
    marginTop: "17px",
    maxHeight: "145px",
    [theme.breakpoints.up("md")]: {
        marginBottom: "28px",
    },
    [theme.breakpoints.up("lg")]: {
        marginLeft: "40px",
        marginRight: "40px",
        marginBottom: "14px",
        marginTop: "24px",
        maxHeight: "none",
    },
}));

export default ConfiguratorInnerBox;
